import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeChatModal } from 'shared/map-search/actions/chatModal';
import { ChatModal } from 'shared/map-search/components/ChatModal';
import { ChatModalOwnOffer } from 'shared/map-search/components/ChatModalOwnOffer/ChatModalOwnOffer';
import {
  selectIsChatModalOpen,
  selectOfferChatAuthorId,
  selectOfferChatGaLabel,
  selectOfferChatProduct,
} from 'shared/map-search/selectors/chatModal';
import { selectUserId } from 'shared/map-search/selectors/user';

import { useSrcChat } from './hooks';
import { trackModalOpen } from './utils/tracking';

export const ChatModalContainer = () => {
  const dispatch = useDispatch();

  const gaLabel = useSelector(selectOfferChatGaLabel);
  const isOpen = useSelector(selectIsChatModalOpen);

  const authorId = useSelector(selectOfferChatAuthorId);
  const userId = useSelector(selectUserId);
  const product = useSelector(selectOfferChatProduct);
  const src = useSrcChat(isOpen);

  const onOpen = React.useCallback(() => {
    trackModalOpen(gaLabel, product);
  }, [gaLabel, product]);

  const onClose = React.useCallback(() => {
    dispatch(closeChatModal());
  }, [dispatch]);

  if (!isOpen) {
    return null;
  }

  if (authorId && userId && authorId === userId) {
    return <ChatModalOwnOffer isOpen={isOpen} onClose={onClose} />;
  }

  return <ChatModal isOpen={isOpen} src={src} onClose={onClose} onOpen={onOpen} />;
};
